// Generated with util/create-component.js
import Table from './Body';

export default Table;
